import { HeaderText, SubheaderText } from "@/components/ui/texts";
import { useTranslation } from "react-i18next";

export const PrivacyPolicy = () => {
  const { i18n } = useTranslation();

  if (i18n.language === "en") {
    return (
      <div id="container-privacy" style={{ textAlign: "start" }}>
        <HeaderText>Privacy Policy</HeaderText>
        <div style={{ textAlign: "start" }}>
          Manel Castro (full name Manel Jose Castro I Fonseca), as a
          representative of Restdali.com, informs you about its Privacy Policy
          regarding the treatment and protection of personal data of users and
          clients that may be collected through browsing or contracting services
          through the website https://www.restdali.com In this sense, the Owner
          guarantees compliance with current regulations regarding the
          protection of personal data, reflected in Organic Law 3/2018, of
          December 5, of Protection of Personal Data and Guarantee of Digital
          Rights (LOPD GDD). It also complies with Regulation (EU) 2016/679 of
          the European Parliament and of the Council of 27 April 2016 on the
          protection of natural persons (GDPR). Use of the website implies
          acceptance of this Privacy Policy as well as the conditions included
          in the Legal Notice. <br></br>
          <SubheaderText style={{ display: "block", marginTop: 20 }}>
            Identity of the person responsible
          </SubheaderText>
          <ul className="ul">
            <li>Owner: Manel Castro (full name Manel Jose Castro I Fonseca)</li>
            <li>ID : 20580069Z</li>
            <li>Address: Avenida Nuria 13, 08758 - Cervelló</li>
            <li>Email: contacto@restdali.com</li>
            <li>Website: https://www.restdali.com</li>
          </ul>
          <SubheaderText style={{ display: "block", marginTop: 20 }}>
            Principles applied in data processing
          </SubheaderText>
          In the processing of your personal data, the The Owner will apply the
          following principles that comply with the requirements of the new
          European data protection regulation:
          <ul className="ul">
            <li>
              <strong>Principle of legality, loyalty and transparency</strong>:
              The Owner will always require consent for the processing of your
              personal data, which may be for one or several specific purposes
              about which he will inform you in advance with absolute
              transparency.{" "}
            </li>
            <li>
              <strong>Principle of data minimization</strong>: The Owner will
              only request the data that is strictly necessary for the purpose
              or purposes for which it is requested.
            </li>
            <li>
              <strong>
                Principle of limitation of the conservation period
              </strong>
              : The data will be kept for the time strictly necessary for the
              purpose or purposes of the treatment. The Owner will inform you of
              the corresponding conservation period according to the purpose. In
              the case of subscriptions, the Owner will periodically review the
              lists and remove those records that have been inactive for a
              considerable period of time.{" "}
            </li>
            <li>
              <strong>Principle of integrity and confidentiality</strong>: Your
              data will be treated in such a way that its security,
              confidentiality and integrity are guaranteed. You should know that
              the Owner takes the necessary precautions to prevent access
              unauthorized or improper use of user data by third parties.
            </li>
          </ul>
          <SubheaderText style={{ display: "block", marginTop: 20 }}>
            Obtaining personal data
          </SubheaderText>{" "}
          <br></br>
          To browse https://www.restdali.com you do not need to provide any
          personal data. The cases in which you do provide your personal data
          are the following:
          <ul className="ul">
            <li>When you register on the website</li>
            <li>When you fill out the contact form</li>
          </ul>
          <SubheaderText style={{ display: "block", marginTop: 20 }}>
            Your rights
          </SubheaderText>
          <br></br>
          The Owner informs you that regarding your personal data you have the
          right to:
          <ul className="ul">
            <li>Request access to the data stored.</li>
            <li>Request rectification or cancellation.</li>
            <li>Request limitation of processing.</li>
            <li>Oppose processing.</li>
            <li> Request the portability of your data.</li>
          </ul>
          The exercise of these rights is personal and therefore must be
          exercised directly by the interested party, requesting it directly
          from the Owner, which means that any client, subscriber or
          collaborator who has provided their data at any time can contact the
          Owner and request information about the data that is stored and how it
          is has obtained, request rectification of the same, request the
          portability of your personal data, oppose the treatment, limit its use
          or request the cancellation of said data in the files of the Owner. To
          exercise your rights of access, rectification, cancellation,
          portability and opposition you must send an email to
          contacto@restdali.com along with valid proof of law such as a
          photocopy of the D.N.I. or equivalent. You have the right to effective
          judicial protection and to file a claim with the control authority, in
          this case, the Spanish Data Protection Agency, if you consider that
          the processing of personal data that concerns you infringes the
          Regulation.
          <br></br>
          <SubheaderText style={{ display: "block", marginTop: 20 }}>
            Purpose of processing personal data
          </SubheaderText>
          <br></br>
          When you connect or use the Website (e.g. navigate the website), send
          an email to the Owner or make a purchase, you are providing personal
          information for which the Owner is responsible. This information may
          include personal data such as your IP address, name and surname,
          physical address, email address, telephone number, browser history
          data, user interactions with the web, and other information. By
          providing this information, you give your consent for your information
          to be collected, used, managed and stored by Manel Castro, only as
          described in the Legal Notice and in this Privacy Policy. The personal
          data and the purpose of processing by the Owner is different depending
          on the information capture system:
          <ul className="ul">
            <li>
              <strong>Registration form</strong>: The Owner requests the
              following personal data: Name and surname, email address and
              telephone number.
            </li>
            <li>
              <strong>Contact form</strong>: The Owner requests the following
              personal data: Name and email address
            </li>
            <li>
              The data you provide to the Owner will be located on the Google
              Cloud services in Madrid.
            </li>
          </ul>
          There are other purposes for which the Owner processes your personal
          data:
          <ul className="ul">
            <li>
              To ensure compliance with the conditions set forth in the Legal
              Notice and in applicable law. This may include the development of
              tools and algorithms that help this Website to guarantee the
              confidentiality of the personal data it collects.
            </li>
            <li>
              To support and improve the services offered by this website.
            </li>
            <li>
              To analyse navigation. The Owner collects other non-identifying
              data that is obtained through the use of cookies that are
              downloaded to your computer when you browse the website, the
              characteristics and purpose of which are detailed in the Cookies
              Policy.
            </li>
            <li>Statistical analysis and profit generation.</li>
          </ul>
          <br></br>
          <SubheaderText style={{ display: "block", marginTop: 20 }}>
            Security of personal data
          </SubheaderText>
          <br></br>
          To protect your personal data, the Owner takes all reasonable
          precautions and follows industry best practices to prevent their loss,
          misuse, improper access, disclosure, alteration or destruction. The
          website is hosted on AMAZON AWS ​​in Frankfurt. The security of your
          data is guaranteed, as they take all necessary security measures to do
          so. You can consult their privacy policy for more information.
          <br></br>
          <SubheaderText style={{ display: "block", marginTop: 20 }}>
            Content from other websites
          </SubheaderText>
          <br></br>
          Pages on this website may include embedded content (e.g. videos,
          images, articles, etc.). Embedded content from other websites behaves
          in exactly the same way as if you had visited the other website. These
          websites may collect data about you, use cookies, embed additional
          third-party tracking code, and monitor your interaction using this
          code.
          <br></br>
          <SubheaderText style={{ display: "block", marginTop: 20 }}>
            Cookie Policy
          </SubheaderText>
          <br></br>In order for this website to function properly, it needs to
          use cookies, which is information stored in your web browser. On the
          Cookies Policy page you can consult all the information regarding the
          collection policy, the purpose and the treatment of cookies.
          <br></br>
          <SubheaderText style={{ display: "block", marginTop: 20 }}>
            Legitimation for data processing
          </SubheaderText>
          <br></br>
          The legal basis for the processing of your data is: consent. To
          contact the Owner, subscribe to a newsletter or make comments on this
          website you must accept this Privacy Policy.
          <br></br>
          <SubheaderText style={{ display: "block", marginTop: 20 }}>
            Categories of personal data
          </SubheaderText>
          <br></br>
          The categories of personal data that the Owner processes are:
          <ul className="ul">
            <li>Identification data.</li>
          </ul>
          <br></br>
          <SubheaderText style={{ display: "block", marginTop: 20 }}>
            Storage of personal data
          </SubheaderText>
          <br></br>
          The personal data that you provide to the Owner will be kept until you
          request its deletion or until a reasonable period of time passes
          without you accessing it. <br></br>
          <SubheaderText style={{ display: "block", marginTop: 20 }}>
            Recipients of personal data
          </SubheaderText>
          <br></br>
          <ul className="ul">
            <li>
              <strong>Google Analytics</strong> is a web analytics service
              provided by Google, Inc., a Delaware company whose main office is
              at 1600 Amphitheatre Parkway, Mountain View (California), CA
              94043, United States ("Google"). You can find more information at:
              <a href="https://analytics.google.com">
                https://analytics.google.com
              </a>
              Google Analytics uses "cookies", which are text files placed on
              your computer, to help the Owner analyze how users use the
              Website. The information generated by the cookie about your use of
              the website (including your IP address) will be transmitted to and
              stored by Google on servers in the United States.
            </li>
            <li>
              <strong>DoubleClick by Google</strong> is a set of advertising
              services provided by Google, Inc., a Delaware company whose main
              office is at 1600 Amphitheatre Parkway, Mountain View
              (California), CA 94043, United States (“Google”). You can find
              more information at:
              <a href="https://www.doubleclickbygoogle.com">
                https://www.doubleclickbygoogle.com
              </a>
              DoubleClick uses “cookies”, which are text files placed on your
              computer and used to increase the relevance of ads related to your
              recent searches. Google’s Privacy Policy explains how Google
              manages your privacy with regard to the use of cookies and other
              information.{" "}
            </li>
          </ul>
          You can also see a list of the types of cookies used by Google and its
          collaborators and all the information related to their use of
          advertising cookies.<br></br>
          <SubheaderText style={{ display: "block", marginTop: 20 }}>
            Web Browsing
          </SubheaderText>
          <br></br>
          When browsing https://www.restdali.com, non-identifying data may be
          collected, which may include the IP address, geolocation, a record of
          how the services and sites are used, browsing habits and other data
          that cannot be used to identify you. The Website uses the following
          third-party analysis services:
          <ul className="ul">
            <li>Google Analytics</li>
            <li>DoubleClick by Google</li>
          </ul>
          The Owner uses the information obtained to obtain statistical data,
          analyze trends, manage the site, study navigation patterns and to
          collect demographic information. <br></br>
          <SubheaderText style={{ display: "block", marginTop: 20 }}>
            Accuracy and truthfulness of personal data
          </SubheaderText>
          <br></br>
          You agree that the data provided to the Owner are correct, complete,
          accurate and current, as well as to keep them duly updated. As a User
          of the Website, you are solely responsible for the truthfulness and
          correctness of the data you send to the site, exonerating the Owner of
          any liability. ier responsibility in this regard.<br></br>
          <SubheaderText style={{ display: "block", marginTop: 20 }}>
            Acceptance and consent
          </SubheaderText>
          <br></br>
          As a User of the Website, you declare that you have been informed of
          the conditions regarding the protection of personal data, and you
          accept and consent to the processing of the same by the Owner in the
          manner and for the purposes indicated in this Privacy Policy.
          <br></br>
          <SubheaderText style={{ display: "block", marginTop: 20 }}>
            Revocability
          </SubheaderText>
          <br></br>
          To exercise your rights of access, rectification, cancellation,
          portability and opposition, you must send an email to
          contacto@restdali.com along with valid proof of law such as a
          photocopy of your ID or equivalent. The exercise of your rights does
          not include any data that the Owner is obliged to retain for
          administrative, legal or security purposes.<br></br>
          <SubheaderText style={{ display: "block", marginTop: 20 }}>
            COOKIE CONSENT
          </SubheaderText>
          To ensure optimal functioning of our website, we use cookies. Cookies
          are small text files that are stored on your device. You can find
          detailed information about the types of cookies we use and how to
          manage your cookie preferences in our Cookie Policy.
          <SubheaderText style={{ display: "block", marginTop: 20 }}>
            DATA RETENTION PERIODS
          </SubheaderText>
          Personal data will be retained for as long as necessary to fulfill the
          purposes for which it was collected. Specific retention periods may
          vary depending on the type of data and the purpose of processing. For
          example, data relating to financial transactions will be retained for
          a longer period of time due to legal and tax requirements.
          <SubheaderText style={{ display: "block", marginTop: 20 }}>
            SECURITY INCIDENTS
          </SubheaderText>
          In the event of a security breach that may result in unauthorized
          access to or disclosure of your personal data, we will take immediate
          steps to investigate the incident, notify you if necessary, and take
          appropriate corrective action.
          <SubheaderText style={{ display: "block", marginTop: 20 }}>
            DATA OF MINORS
          </SubheaderText>
          Our website is not directed to minors. If you are under 18 years of
          age, you should not provide personal information through our website
          without the consent of your parents or legal guardian.
          <SubheaderText style={{ display: "block", marginTop: 20 }}>
            PRIVACY POLICY UPDATES
          </SubheaderText>
          We may update this Privacy Policy from time to time to reflect changes
          in the law, industry practices, or our own operations. We will notify
          you of any significant changes and provide you with the opportunity to
          review the updated policy.
        </div>
      </div>
    );
  }

  return (
    <div id="container-privacy" style={{ textAlign: "start" }}>
      <HeaderText>Política de privacidad</HeaderText>
      <div style={{ textAlign: "start" }}>
        Manel Castro (con nombre completo Manel Jose Castro I Fonseca), como
        representante de Restdali.com, te informa sobre su Política de
        Privacidad respecto del tratamiento y protección de los datos de
        carácter personal de los usuarios y clientes que puedan ser recabados
        por la navegación o contratación de servicios a través del sitio Web
        https://www.restdali.com En este sentido, el Titular garantiza el
        cumplimiento de la normativa vigente en materia de protección de datos
        personales, reflejada en la Ley Orgánica 3/2018, de 5 de diciembre, de
        Protección de Datos Personales y de Garantía de Derechos Digitales (LOPD
        GDD). Cumple también con el Reglamento (UE) 2016/679 del Parlamento
        Europeo y del Consejo de 27 de abril de 2016 relativo a la protección de
        las personas físicas (RGPD). El uso de sitio Web implica la aceptación
        de esta Política de Privacidad así como las condiciones incluidas en el
        Aviso Legal.
        <br></br>
        <SubheaderText style={{ display: "block", marginTop: 20 }}>
          Identidad del responsable
        </SubheaderText>
        <ul className="ul">
          <li>
            Titular: Manel Castro (con nombre completo Manel Jose Castro I
            Fonseca)
          </li>
          <li>DNI: 20580069Z</li>
          <li>Domicilio: Avenida Nuria 13, 08758 - Cervelló</li>
          <li>Correo electrónico: contacto@restdali.com</li>
          <li>Sitio web: https://www.restdali.com</li>
        </ul>
        <SubheaderText style={{ display: "block", marginTop: 20 }}>
          Principios aplicados en el tratamiento de datos
        </SubheaderText>
        En el tratamiento de tus datos personales, el Titular aplicará los
        siguientes principios que se ajustan a las exigencias del nuevo
        reglamento europeo de protección de datos:
        <ul className="ul">
          <li>
            <strong>Principio de licitud, lealtad y transparencia</strong>: El
            Titular siempre requerirá el consentimiento para el tratamiento de
            tus datos personales que puede ser para uno o varios fines
            específicos sobre los que te informará previamente con absoluta
            transparencia.
          </li>
          <li>
            <strong>Principio de minimización de datos</strong>: El Titular te
            solicitará solo los datos estrictamente necesarios para el fin o los
            fines que los solicita.
          </li>
          <li>
            <strong>Principio de limitación del plazo de conservación</strong>
            : Los datos se mantendrán durante el tiempo estrictamente necesario
            para el fin o los fines del tratamiento. El Titular te informará del
            plazo de conservación correspondiente según la finalidad. En el caso
            de suscripciones, el Titular revisará periódicamente las listas y
            eliminará aquellos registros inactivos durante un tiempo
            considerable.
          </li>
          <li>
            <strong>Principio de integridad y confidencialidad</strong>: Tus
            datos serán tratados de tal manera que su seguridad,
            confidencialidad e integridad esté garantizada. Debes saber que el
            Titular toma las precauciones necesarias para evitar el acceso no
            autorizado o uso indebido de los datos de sus usuarios por parte de
            terceros.
          </li>
        </ul>
        <SubheaderText style={{ display: "block", marginTop: 20 }}>
          Obtención de datos personales
        </SubheaderText>
        <br></br>
        Para navegar por https://www.restdali.com no es necesario que facilites
        ningún dato personal. Los casos en los que sí proporcionas tus datos
        personales son los siguientes:
        <ul className="ul">
          <li>Al registrarte en la web</li>
          <li>Al rellenar el formulario de contacto</li>
        </ul>
        <SubheaderText style={{ display: "block", marginTop: 20 }}>
          Tus derechos
        </SubheaderText>
        <br></br>
        El Titular te informa que sobre tus datos personales tienes derecho a:
        <ul className="ul">
          <li>Solicitar el acceso a los datos almacenados.</li>
          <li>Solicitar una rectificación o la cancelación.</li>
          <li>Solicitar la limitación de su tratamiento.</li>
          <li>Oponerte al tratamiento.</li>
          <li>Solicitar la portabilidad de tus datos.</li>
        </ul>
        El ejercicio de estos derechos es personal y por tanto debe ser ejercido
        directamente por el interesado, solicitándolo directamente al Titular,
        lo que significa que cualquier cliente, suscriptor o colaborador que
        haya facilitado sus datos en algún momento puede dirigirse al Titular y
        pedir información sobre los datos que tiene almacenados y cómo los ha
        obtenido, solicitar la rectificación de los mismos, solicitar la
        portabilidad de sus datos personales, oponerse al tratamiento, limitar
        su uso o solicitar la cancelación de esos datos en los ficheros del
        Titular. Para ejercitar tus derechos de acceso, rectificación,
        cancelación, portabilidad y oposición tienes que enviar un correo
        electrónico a contacto@restdali.com junto con la prueba válida en
        derecho como una fotocopia del D.N.I. o equivalente. Tienes derecho a la
        tutela judicial efectiva y a presentar una reclamación ante la autoridad
        de control, en este caso, la Agencia Española de Protección de Datos, si
        consideras que el tratamiento de datos personales que te conciernen
        infringe el Reglamento.
        <br></br>
        <SubheaderText style={{ display: "block", marginTop: 20 }}>
          Finalidad del tratamiento de datos personales
        </SubheaderText>
        <br></br>
        Cuando te conectas o utilizas el Sitio Web (p. ej. navegas por la web),
        envías un correo electrónico al Titular o realizas una compra, estás
        facilitando información personal de la que es responsable el Titular.
        Esta información puede incluir datos personales como tu dirección IP,
        nombre y apellidos, dirección física, dirección de correo electrónico,
        número de teléfono, datos del historial del navegador, interacciones de
        usuario con la web, y otra información. Al facilitar esta información,
        das tu consentimiento para que tu información sea recopilada, utilizada,
        gestionada y almacenada por Manel Castro, sólo como se describe en el
        Aviso Legal y en esta Política de Privacidad. Los datos personales y la
        finalidad del tratamiento por parte del Titular es diferente en función
        del sistema de captura de información:
        <ul className="ul">
          <li>
            <strong>Formulario de registro</strong>: El Titular solicita los
            siguientes datos personales: Nombre y apellidos, dirección de correo
            electrónico y número de teléfono.
          </li>
          <li>
            <strong>Formulario de contacto</strong>: El Titular solicita los
            siguientes datos personales: Nombre y dirección de correo
            electrónico
          </li>
          <li>
            Los datos que facilites al Titular estarán ubicados en los servicios
            de Google Cloud en Madrid.
          </li>
        </ul>
        Existen otras finalidades por las que el Titular trata tus datos
        personales:
        <ul className="ul">
          <li>
            Para garantizar el cumplimiento de las condiciones establecidas en
            el Aviso Legal y en la legislación aplicable. Esto puede incluir el
            desarrollo de herramientas y algoritmos que ayudan a este Sitio Web
            a garantizar la confidencialidad de los datos personales que recoge.
          </li>
          <li>
            Para apoyar y mejorar los servicios que ofrece este sitio web.
          </li>
          <li>
            Para analizar la navegación. El Titular recoge otros datos no
            identificativos que se obtienen mediante el uso de cookies que se
            descargan en tu ordenador cuando navegas por el sitio Web, cuyas
            características y finalidad están detalladas en la Política de
            Cookies.
          </li>
          <li>Análisis estadístico y generación de beneficios.</li>
        </ul>
        <br></br>
        <SubheaderText style={{ display: "block", marginTop: 20 }}>
          Seguridad de los datos personales
        </SubheaderText>
        <br></br>
        Para proteger tus datos personales, el Titular toma todas las
        precauciones razonables y sigue las mejores prácticas de la industria
        para evitar su pérdida, mal uso, acceso indebido, divulgación,
        alteración o destrucción de los mismos. El sitio Web está alojado en
        AMAZON AWS en Fránkfurt. La seguridad de tus datos está garantizada, ya
        que toman todas las medidas de seguridad necesarias para ello. Puedes
        consultar su política de privacidad para tener más información.
        <br></br>
        <SubheaderText style={{ display: "block", marginTop: 20 }}>
          Contenido de otros sitios web
        </SubheaderText>
        <br></br>
        Las páginas de este sitio Web pueden incluir contenido incrustado (por
        ejemplo, vídeos, imágenes, artículos, etc.). El contenido incrustado de
        otras web se comporta exactamente de la misma manera que si hubieras
        visitado la otra web. Estos sitios Web pueden recopilar datos sobre ti,
        utilizar cookies, incrustar un código de seguimiento adicional de
        terceros, y supervisar tu interacción usando este código.
        <br></br>
        <SubheaderText style={{ display: "block", marginTop: 20 }}>
          Política de Cookies
        </SubheaderText>
        <br></br>
        Para que este sitio Web funcione correctamente necesita utilizar
        cookies, que es una información que se almacena en tu navegador web. En
        la página Política de Cookies puedes consultar toda la información
        relativa a la política de recogida, la finalidad y el tratamiento de las
        cookies.
        <br></br>
        <SubheaderText style={{ display: "block", marginTop: 20 }}>
          Legitimación para el tratamiento de datos
        </SubheaderText>
        <br></br>
        La base legal para el tratamiento de tus datos es: el consentimiento.
        Para contactar con el Titular, suscribirte a un boletín o realizar
        comentarios en este sitio Web tienes que aceptar la presente Política de
        Privacidad.
        <br></br>
        <SubheaderText style={{ display: "block", marginTop: 20 }}>
          Categorías de datos personales
        </SubheaderText>
        <br></br>
        Las categorías de datos personales que trata el Titular son:
        <ul className="ul">
          <li>Datos identificativos.</li>
        </ul>
        <br></br>
        <SubheaderText style={{ display: "block", marginTop: 20 }}>
          Conservación de datos personales
        </SubheaderText>
        <br></br>
        Los datos personales que proporciones al Titular se conservarán hasta
        que solicites su supresión o hasta que pase un tiempo prudencial sin el
        acceso por tu parte.
        <br></br>
        <SubheaderText style={{ display: "block", marginTop: 20 }}>
          Destinatarios de datos personales
        </SubheaderText>
        <br></br>
        <ul className="ul">
          <li>
            <strong>Google Analytics</strong> es un servicio de analítica web
            prestado por Google, Inc., una compañía de Delaware cuya oficina
            principal está en 1600 Amphitheatre Parkway, Mountain View
            (California), CA 94043, Estados Unidos (“Google”). Encontrarás más
            información en: 
            <a href="https://analytics.google.com">
              https://analytics.google.com
            </a>
            Google Analytics utiliza “cookies”, que son archivos de texto
            ubicados en tu ordenador, para ayudar al Titular a analizar el uso
            que hacen los usuarios del sitio Web. La información que genera la
            cookie acerca del uso del sitio Web (incluyendo tu dirección IP)
            será directamente transmitida y archivada por Google en los
            servidores de Estados Unidos.
          </li>
          <li>
            <strong>DoubleClick by Google</strong> es un conjunto de servicios
            publicitarios proporcionado por Google, Inc., una compañía de
            Delaware cuya oficina principal está en 1600 Amphitheatre Parkway,
            Mountain View (California), CA 94043, Estados Unidos (“Google”).
            Encontrarás más información en: 
            <a href="https://www.doubleclickbygoogle.com">
              https://www.doubleclickbygoogle.com
            </a>
            DoubleClick utiliza “cookies”, que son archivos de texto ubicados en
            tu ordenador y que sirven para aumentar la relevancia de los
            anuncios relacionados con tus búsquedas recientes. En la Política de
            privacidad de Google se explica cómo Google gestiona tu privacidad
            en lo que respecta al uso de las cookies y otra información.
          </li>
        </ul>
        También puedes ver una lista de los tipos de cookies que utiliza Google
        y sus colaboradores y toda la información relativa al uso que hacen de
        cookies publicitarias.<br></br>
        <SubheaderText style={{ display: "block", marginTop: 20 }}>
          Navegación Web
        </SubheaderText>
        <br></br>
        Al navegar por https://www.restdali.com se pueden recoger datos no
        identificativos, que pueden incluir, la dirección IP, geolocalización,
        un registro de cómo se utilizan los servicios y sitios, hábitos de
        navegación y otros datos que no pueden ser utilizados para
        identificarte. El sitio Web utiliza los siguientes servicios de análisis
        de terceros:
        <ul className="ul">
          <li>Google Analytics</li>
          <li>DoubleClick por Google</li>
        </ul>
        El Titular utiliza la información obtenida para obtener datos
        estadísticos, analizar tendencias, administrar el sitio, estudiar
        patrones de navegación y para recopilar información demográfica.
        <br></br>
        <SubheaderText style={{ display: "block", marginTop: 20 }}>
          Exactitud y veracidad de los datos personales
        </SubheaderText>
        <br></br>
        Te comprometes a que los datos facilitados al Titular sean correctos,
        completos, exactos y vigentes, así como a mantenerlos debidamente
        actualizados. Como Usuario del sitio Web eres el único responsable de la
        veracidad y corrección de los datos que remitas al sitio exonerando a el
        Titular de cualquier responsabilidad al respecto.<br></br>
        <SubheaderText style={{ display: "block", marginTop: 20 }}>
          Aceptación y consentimiento
        </SubheaderText>
        <br></br>
        Como Usuario del sitio Web declaras haber sido informado de las
        condiciones sobre protección de datos de carácter personal, aceptas y
        consientes el tratamiento de los mismos por parte de el Titular en la
        forma y para las finalidades indicadas en esta Política de Privacidad.
        <br></br>
        <SubheaderText style={{ display: "block", marginTop: 20 }}>
          Revocabilidad
        </SubheaderText>
        <br></br>
        Para ejercitar tus derechos de acceso, rectificación, cancelación,
        portabilidad y oposición tienes que enviar un correo electrónico a
        contacto@restdali.com junto con la prueba válida en derecho como una
        fotocopia del D.N.I. o equivalente. El ejercicio de tus derechos no
        incluye ningún dato que el Titular esté obligado a conservar con fines
        administrativos, legales o de seguridad.<br></br>
        <SubheaderText style={{ display: "block", marginTop: 20 }}>
          CONSENTIMIENTO DE COOKIES
        </SubheaderText>
        Para garantizar un funcionamiento óptimo de nuestro sitio web,
        utilizamos cookies. Las cookies son pequeños archivos de texto que se
        almacenan en tu dispositivo. Puedes encontrar información detallada
        sobre los tipos de cookies que utilizamos y cómo gestionar tus
        preferencias de cookies en nuestra Política de Cookies.
        <SubheaderText style={{ display: "block", marginTop: 20 }}>
          PERIODOS DE RETENCIÓN DE DATOS
        </SubheaderText>
        Los datos personales se conservarán durante el tiempo necesario para
        cumplir los fines para los que fueron recopilados. Los plazos de
        retención específicos pueden variar según el tipo de datos y la
        finalidad del tratamiento. Por ejemplo, los datos relacionados con las
        transacciones financieras se conservarán durante un período de tiempo
        más largo debido a requisitos legales y fiscales.
        <SubheaderText style={{ display: "block", marginTop: 20 }}>
          INCIDENCIAS DE SEGURIDAD
        </SubheaderText>
        En caso de una violación de seguridad que pueda resultar en el acceso no
        autorizado o la divulgación de tus datos personales, tomaremos medidas
        inmediatas para investigar el incidente, notificarte si es necesario y
        tomar las acciones correctivas apropiadas.
        <SubheaderText style={{ display: "block", marginTop: 20 }}>
          DATOS DE MENORES
        </SubheaderText>
        Nuestro sitio web no está dirigido a menores de edad. Si eres menor de
        18 años, no debes proporcionar información personal a través de nuestro
        sitio web sin el consentimiento de tus padres o tu tutor legal.
        <SubheaderText style={{ display: "block", marginTop: 20 }}>
          ACTUALIZACIONES DE LA POLÍTICA DE PRIVACIDAD
        </SubheaderText>
        Podemos actualizar esta Política de Privacidad de vez en cuando para
        reflejar cambios en la legislación, las prácticas de la industria o
        nuestras propias operaciones. Te notificaremos de cualquier cambio
        significativo y te proporcionaremos la oportunidad de revisar la
        política actualizada.
      </div>
    </div>
  );
};
